<template>
    <div>
        <div class="checkwarp">
            <div class="warp">
                <a-radio-group v-model="mode" :style="{ marginBottom: '8px' }">
                    <a-radio-button value="1">
                        员工
                    </a-radio-button>
                    <a-radio-button value="2">
                        部门
                    </a-radio-button>
                </a-radio-group>
                <div v-if="mode === '1'" class="checkwarp-box">
                    <a-input-search placeholder="搜索员工" style="width: 170px" @change='handleEmployee' @search="onSearchEmployee" />
                    <div class="checkwarp-user">
                        <vue-element-loading :active="loading" color="#00cca2" spinner="spinner"/>
                        <div style="margin:5px 0" v-for="item in staffList" :key="item.employee_id">
                            <a-checkbox :checked="item.isCheck" @click="toCheckEmployee(item)">{{item.filter_name}}</a-checkbox>
                        </div>
                    </div>
                </div>
                <div v-else class="checkwarp-box">
                    <a-input-search placeholder="搜索部门" style="width: 170px" @search="onSearch" />
                    <div style="margin:5px 0">
                        <a-breadcrumb separator=">">
                            <a-breadcrumb-item style="cursor: pointer;" v-for="(item,index) in departmentNav" :key="index" >
                                <span @click="changeDepartment(item,index)">{{item.department_name}}</span>
                            </a-breadcrumb-item>
                        </a-breadcrumb>
                    </div>
                    <div class="checkwarp-user">
                        <div style="margin:5px 0;position: relative;cursor: pointer;display: flex;align-items: center;" @click="toChildDepartment(item)" v-for="item in DepOptionsChild" :key="item.department_id">
                            <a-checkbox :checked="item.isCheck" @click.stop="toCheckDepartment(item)"></a-checkbox>
                            <span style="margin-left:5px">{{item.department_name}}</span>
                            <a-icon style="position:absolute;right: 0;" type="right" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="warp" style="margin-left:15px">
                <div style="position:relative;height: 32px;margin-bottom:8px;line-height:32px">
                    <span>已选择员工({{send_employee_ids.length}}) 部门 ({{send_structure_ids.length}})</span>
                    <span @click="toClear" style="position:absolute;right:0">清空</span>
                </div>
                <div class="checkwarp-box">
                    <div class="checkwarp-user">
                        <div style="margin:5px 0;position: relative;display: flex;align-items: center;" v-for="(item,index) in check_name_list" :key="index">
                            <span>{{item.filter_name || item.department_name}}</span>
                            <a-icon @click="toDelete(item)" style="position:absolute;right:0" type="delete" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="text-align:right;padding:5px 0">
            <a-button @click="confirm" type="primary">确认</a-button>
            <a-button @click="hideCheckWarp" style="margin-left:10px">取消</a-button>
        </div>
    </div>
</template>

<script>
    export default {
        name:'CheckWarp',
        inject: ['parent'],
        data() {
            return {
                loading:false,
                mode: '1',
                staffList:[],
                send_employee_ids:[],
                send_employee_list:[],
                check_name_list:[],
                DepOptions:[],
                DepOptionsChild:[],
                DepOptionsChildF:[],
                send_structure_ids:[],
                send_structure_list:[],
                departmentNav:[],
            }
        },
        created () {
            this.check_name_list = JSON.parse(this.$ls.get('check_name_list')) || []
            this.send_employee_ids = JSON.parse(this.$ls.get('send_employee_ids')) || []
            this.send_employee_list = JSON.parse(this.$ls.get('send_employee_list')) || []
            this.send_structure_ids = JSON.parse(this.$ls.get('send_structure_ids')) || []
            this.send_structure_list = JSON.parse(this.$ls.get('send_structure_list')) || []
            this.getStaff()
            this.getDepartment()
        },
        methods: {
            async getStaff(val){
                this.loading = true
                let obj = {q:val}
                let res = await this.$store.dispatch('searchAccountEmployeeAction', {params:obj,data:{active:true}})
                this.staffList = res.data
                this.screenEmployee(res.data)
                this.loading = false
            },
            async getDepartment(){
                let res = await this.$store.dispatch('employeeOrganizationAction', {})
                this.DepOptions = res.data
                res.data.forEach(item=>{
                    item.isCheck = false
                })
                this.DepOptionsChild = res.data
                this.DepOptionsChildF = res.data.children
                this.departmentNav.push({department_name:'全部',children:res.data})
            },
            screenEmployee(arr){
                arr.forEach(item=>{
                    item.isCheck = false
                })
                arr.forEach(item=>{
                    this.send_employee_ids.forEach(it=>{
                        if(item.employee_id == it){
                            item.isCheck = true
                        }
                    })
                })
                return arr
            },
            handleEmployee(e){
                this.getStaff(e.target.value)
            },
            onSearchEmployee(e) {
                this.getStaff(e)
            },
            toCheckEmployee(item){
                if(item.isCheck){
                    item.isCheck = false
                    let index = this.send_employee_ids.indexOf(item.employee_id)
                    this.send_employee_ids.splice(index,1)
                    this.send_employee_list.splice(index,1)
                }else{
                    item.isCheck = true
                    this.send_employee_ids.push(item.employee_id)
                    this.send_employee_list.push(item)
                }
                this.check_name_list = [...this.send_structure_list,...this.send_employee_list]
                this.$forceUpdate()
            },
            toChildDepartment(item){
                if(!item.children){
                    return false
                }
                item.children.forEach(item=>{
                    item.isCheck = false
                })
                item.children.forEach(item=>{
                    this.send_structure_ids.forEach(it=>{
                        if(item.department_id == it){
                            item.isCheck = true
                        }
                    })
                })
                this.DepOptionsChild = item.children
                this.DepOptionsChildF = item
                this.departmentNav.push(item)
            },
            changeDepartment(item,index){
                let list = []
                for(let i=0; i<= index; i++){
                    list.push(this.departmentNav[i])
                }
                this.departmentNav = list
                item.children.forEach(item=>{
                    item.isCheck = false
                })
                item.children.forEach(item=>{
                    this.send_structure_ids.forEach(it=>{
                        if(item.department_id == it){
                            item.isCheck = true
                        }
                    })
                })
                this.DepOptionsChild = item.children
                this.DepOptionsChildF = item
            },
            toCheckDepartment(item){
                if(item.isCheck){
                    item.isCheck = false
                    let index = this.send_structure_ids.indexOf(item.department_id)
                    this.send_structure_ids.splice(index,1)
                    this.send_structure_list.splice(index,1)
                }else{
                    item.isCheck = true
                    this.send_structure_ids.push(item.department_id)
                    this.send_structure_list.push(item)
                }
                this.check_name_list = [...this.send_structure_list,...this.send_employee_list]
                this.$forceUpdate()
            },
            onSearch(e){

            },
            toClear(){
                this.check_name_list = []
                this.send_employee_ids = []
                this.send_employee_list = []
                this.send_structure_ids = []
                this.send_structure_list = []
                this.staffList.forEach(item=>{
                    item.isCheck = false
                })
                console.log(this.DepOptionsChild,this.DepOptionsChildF)
                this.DepOptionsChild.forEach(item=>{
                    item.isCheck = false
                    if(item.children){
                        item.children.forEach(it=>{
                            it.isCheck = false
                        })
                    }
                })
                if(this.DepOptionsChildF){
                    this.DepOptionsChildF.isCheck = false
                    this.DepOptionsChildF.children.forEach(item=>{
                        item.isCheck = false
                    })
                }
                this.$ls.remove('check_name_list')
                this.$ls.remove('send_employee_ids')
                this.$ls.remove('send_employee_list')
                this.$ls.remove('send_structure_ids')
                this.$ls.remove('send_structure_list')
            },
            toDelete(item){
                if(item.employee_id){
                    let index = this.send_employee_ids.indexOf(item.employee_id)
                    this.send_employee_ids.splice(index,1)
                    this.send_employee_list.splice(index,1)
                    this.staffList.forEach(it=>{
                        if(it.employee_id == item.employee_id){
                            it.isCheck = false
                        }
                    })
                }
                if(item.department_id){
                    let index = this.send_structure_ids.indexOf(item.department_id)
                    this.send_structure_ids.splice(index,1)
                    this.send_structure_list.splice(index,1)
                }
                this.check_name_list = [...this.send_structure_list,...this.send_employee_list]
                this.$forceUpdate()
            },
            hideCheckWarp(){
                this.parent.hideCheckWarp()
            },
            confirm(){
                this.$ls.set('check_name_list',JSON.stringify(this.check_name_list))
                this.$ls.set('send_employee_ids',JSON.stringify(this.send_employee_ids))
                this.$ls.set('send_employee_list',JSON.stringify(this.send_employee_list))
                this.$ls.set('send_structure_ids',JSON.stringify(this.send_structure_ids))
                this.$ls.set('send_structure_list',JSON.stringify(this.send_structure_list))
                this.parent.hideCheckWarp(1)
            }
        },
    }
</script>

<style lang="scss">
    .checkwarp{
        display: flex;
        .warp{
            width: 250px;
        }
        .checkwarp-box{
            height: 340px;
            padding: 15px;
            border: 1px solid #ebedf0;
        }
        .checkwarp-user{
            height: 250px;
            overflow-y: auto;
        }
    }
</style>